// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RknG","delete":"styles_delete__1_Gth","update":"styles_update__hSRaq","add":"styles_add__XnC0x"};